<template>
  <div>
    <h4>{{ data.title }}</h4>

    <div v-if="data.description">
      <h6 class="my-3">Вопрос:</h6>
      <RichEditor
        v-model="data.description"
        @focus="focus($event)"
      />
    </div>
  </div>
</template>

<script>
import RichEditor from "@/components/Editor/RichTextEditor.vue";

export default {
  data() {
    return {
      editorOption: {
        modules: {
          toolbar: [],
        },
        readOnly: true,
        theme: "snow",
      },
    };
  },
  props: ["data"],
  components: {
    RichEditor,
  },
  methods: {
    focus(event) {
      event.enable(false);
    },
  },
};
</script>
